import { render, staticRenderFns } from "./Vip.vue?vue&type=template&id=286fbd76&scoped=true"
import script from "./Vip.vue?vue&type=script&lang=js"
export * from "./Vip.vue?vue&type=script&lang=js"
import style0 from "./Vip.vue?vue&type=style&index=0&id=286fbd76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286fbd76",
  null
  
)

export default component.exports